import React, { Component, forwardRef } from 'react'
import PropTypes from 'prop-types'
import DatePickerReact, { registerLocale } from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import de from 'date-fns/locale/de'
import en from 'date-fns/locale/en-GB'
import { withTranslation } from 'react-i18next'
import Input from '../Form/Input'
import './styles.scss'

registerLocale('de', de)
registerLocale('en', en)

class DatePicker extends Component {
  render () {
    const CustomInput = forwardRef(({ value, onClick }, ref) => (
      <div style={{ display: 'flex' }}>
        <div onClick={onClick} style={{ width: '100%', flex: 1 }}>
          <Input ref={ref} value={value} disabled={true} onChange={() => {}}/>
        </div>
      </div>))

    return (
      <DatePickerReact
        selected={this.props.selected}
        locale={this.props.i18n.language}
        onChange={date => this.props.onChange(date)}
        strictParsing
        isClearable
        customInput={<CustomInput/>}
      />
    )
  }
}

DatePicker.propTypes = {
  onChange: PropTypes.func.isRequired,
  selected: PropTypes.instanceOf(Date),
}
export default withTranslation()(DatePicker)
